/**
 * Branch Point Service
 */

import { httpClient } from '../http-client';

const API_BASE_URL = '/api/v1';

export const BranchPointService = {
  /**
   */
  async initBranchPoint(params: {
    treeId: string;
    nodeId: string;
    centralTopic: string;
    compressedContext: string;
    branchNodeTitle: string;
    branchDescription: string;
    language?: string;
  }): Promise<{
    workflowId: string;
    options: Array<{ title: string; description: string }>;
    regenerationCount: number;
    status: string;
  }> {
    try {
      const url = `${API_BASE_URL}/learning-trees/${params.treeId}/nodes/${params.nodeId}/branch-point/init`;
      const response = await httpClient.post<{
        workflowId: string;
        options: Array<{ title: string; description: string }>;
        regenerationCount: number;
        status: string;
      }>(url, {
        centralTopic: params.centralTopic,
        compressedContext: params.compressedContext,
        branchNodeTitle: params.branchNodeTitle,
        branchDescription: params.branchDescription,
        language: params.language || 'ko',
      });
      return response.data;
    } catch (error) {
      console.error('Error initializing branch point:', error);
      throw error;
    }
  },

  /**
   */
  async regenerateBranchOptions(params: {
    treeId: string;
    nodeId: string;
  }): Promise<{
    workflowId: string;
    options: Array<{ title: string; description: string }>;
    regenerationCount: number;
  }> {
    try {
      const url = `${API_BASE_URL}/learning-trees/${params.treeId}/nodes/${params.nodeId}/branch-point/regenerate`;
      const response = await httpClient.post<{
        workflowId: string;
        options: Array<{ title: string; description: string }>;
        regenerationCount: number;
      }>(url);
      return response.data;
    } catch (error) {
      console.error('Error regenerating branch options:', error);
      throw error;
    }
  },

  /**
   */
  async confirmBranchSelection(params: {
    treeId: string;
    nodeId: string;
    selectedOption: { title: string; description: string };
  }): Promise<{
    workflowId: string;
    message: string;
  }> {
    try {
      const url = `${API_BASE_URL}/learning-trees/${params.treeId}/nodes/${params.nodeId}/branch-point/confirm`;
      const response = await httpClient.post<{
        workflowId: string;
        message: string;
      }>(url, {
        selectedOption: params.selectedOption,
      });
      return response.data;
    } catch (error) {
      console.error('Error confirming branch selection:', error);
      throw error;
    }
  },

  /**
   */
  async getBranchPointStatus(params: {
    treeId: string;
    nodeId: string;
  }): Promise<{
    workflowId: string;
    status: 'RUNNING' | 'COMPLETED' | 'FAILED';
    options?: Array<{ title: string; description: string }>;
    regenerationCount?: number;
    result?: unknown;
    error?: string;
  }> {
    try {
      const url = `${API_BASE_URL}/learning-trees/${params.treeId}/nodes/${params.nodeId}/branch-point/status`;
      const response = await httpClient.get<{
        workflowId: string;
        status: 'RUNNING' | 'COMPLETED' | 'FAILED';
        options?: Array<{ title: string; description: string }>;
        regenerationCount?: number;
        result?: unknown;
        error?: string;
      }>(url);
      return response.data;
    } catch (error) {
      console.error('Error getting branch point status:', error);
      throw error;
    }
  },

  /**
   * @deprecated Use initBranchPoint instead
   */
  async generateBranchOptions(params: {
    treeId: string;
    nodeId: string;
    centralTopic: string;
    language: string;
    branchNodeTitle: string;
    branchDescription: string;
  }): Promise<{ options: Array<{ title: string; description: string }> }> {
    try {
      const url = `${API_BASE_URL}/learning-trees/${params.treeId}/nodes/${params.nodeId}/branch-options`;
      const response = await httpClient.post<{ options: Array<{ title: string; description: string }> }>(url, {
        centralTopic: params.centralTopic,
        language: params.language,
        branchNodeTitle: params.branchNodeTitle,
        branchDescription: params.branchDescription,
      });
      return response.data;
    } catch (error) {
      console.error('Error generating branch options:', error);
      throw error;
    }
  },
};
